/**
 * get the first string index for regex
 * taken and slightly modified from
 * https://stackoverflow.com/questions/273789/is-there-a-version-of-javascripts-string-indexof-that-allows-for-regular-expr
 * @param {*} regex
 * @param {*} startpos
 */
const stringRegexIndexOf = (stringInput, regex, startpos) => {
  const indexOf = stringInput.substring(startpos || 0).search(regex);
  return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf;
};

/**
 * get the last string index for regex
 * taken and slightly modified from
 * https://stackoverflow.com/questions/273789/is-there-a-version-of-javascripts-string-indexof-that-allows-for-regular-expr
 * @param {*} regex
 * @param {*} startpos
 */
const stringRegexLastIndexOf = (stringInput, regex, startpos) => {
  const regexUse = (regex.global) ? regex : new RegExp(regex.source, `g${regex.ignoreCase ? 'i' : ''}${regex.multiLine ? 'm' : ''}`);
  let startposUse = 0;
  if (typeof (startpos) === 'undefined') {
    startposUse = stringInput.length;
  }
  const stringToWorkWith = stringInput.substring(0, startposUse + 1);
  let lastIndexOf = -1;
  let nextStop = 0;
  let result = '';
  // eslint-disable-next-line no-cond-assign
  while ((result = regexUse.exec(stringToWorkWith)) != null) {
    // add length of found \n or <br> to string length
    lastIndexOf = result.index + result[0].length;
    // eslint-disable-next-line no-plusplus
    regexUse.lastIndex = ++nextStop;
  }

  return lastIndexOf;
};

export {
  stringRegexIndexOf,
  stringRegexLastIndexOf,
};
